import { Component, OnInit } from '@angular/core';

import { ScoreFacade } from '@app/core/facades/score.facade';
import { ScoreType } from '@app/core/models/enumerations/score-type.enum';
import { FilterType } from '@app/shared/components/sub-header/filter-type.model';
import FilterChange from '@app/shared/filters/filter-change.model';
import FilterComponent from '@app/shared/filters/filter.component';

const SIZE = '220px';

@Component({
  selector: 'app-score-component',
  templateUrl: '../filter.component.html',
  styleUrls: ['../filter.component.scss'],
})
export default class ScoreFilterComponent extends FilterComponent implements OnInit {
  /**
   * Size of the dropdown
   * @type {string}
   */
  public readonly width = SIZE;

  /**
   * Label for the dropdown
   * @type {string}
   */
  public readonly label = 'Score';

  public constructor(private readonly _data: ScoreFacade) {
    super();
  }

  /**
   * Updates the selection on change and emits the value
   * @param {string} value
   * @param {boolean} _
   */
  public update(value: string, _: boolean): void {
    this._data.updateScoreId(value as ScoreType);
    this.valueChange.emit(new FilterChange(FilterType.Score, value));
  }

  ngOnInit() {
    this.init(this._data.scoreId$, this._data.scores$, this._data.scores$, 'label');
  }
}
